export function reformatUrl(url?: string): string | undefined {
  if (!url || !url.includes('#')) {
    return url;
  }

  const [base, rest] = url.split('#');
  const [hash, ...params] = rest.split('&');

  if (hash.includes('?')) {
    const [hashPart, query] = hash.split('?');
    return `${base}?${[query, ...params].join('&')}#${hashPart}`;
  }

  const [clean, query] = base.split('?');
  return `${clean}?${[query, ...params].join('&')}#${hash}`;
}
